import { useQuery } from "@tanstack/react-query";
import { testingAxios, testingAuthHeaders } from "@/services/testing";
import { planOpenUrlEndpoint } from "@/services/testing";
import { useAuthStoreV1 } from "@/stores/authStore_v1";

async function fetchOpenUrl(planId: string): Promise<string> {
  const r = await testingAxios.get<{ url: string; instance_url: string }>(
    planOpenUrlEndpoint(planId),
    { headers: testingAuthHeaders() }
  );
  return r.data.url;
}

export function useOpenUrl(planId: string | null) {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);
  const userId = useAuthStoreV1((s) => s.user?.id ?? null);
  return useQuery({
    queryKey: ["testingOpenUrl", planId, orgId],
    queryFn: () => fetchOpenUrl(planId!),
    enabled: !!(token && orgId && userId && planId),
    refetchOnWindowFocus: false,
    // Background fetch for the selected plan — a transient failure must not toast.
    meta: { silent: true },
    retry: 3,
  });
}
